import { __awaiter } from "tslib";
import getOptimizelyDefaultOptions from '../getOptimizelyDefaultOptions';
import initOptimizelyVanillaHelpersSDK from '../initOptimizelyVanillaHelpersSDK';
/**
 * calls instance.isFeatureEnabled('key') function with defualt attributes if optOut cookie is not set.
 *
 * @param  {string} featureKey - Feature flag specific key. Not to be confused with experiment key.
 * @param  {object} customAttributes - customAttributes
 * @returns {Promise <boolean>}
 */
const isOptimizelyVanillaFeatureEnabled = (featureKey, customAttributes = {}) => __awaiter(void 0, void 0, void 0, function* () {
    if (!window.optimizelyVanillaHelpersSDKInstance) {
        yield initOptimizelyVanillaHelpersSDK();
    }
    const { attributes, userId } = getOptimizelyDefaultOptions();
    const enabled = yield window.optimizelyVanillaHelpersSDKInstance.isFeatureEnabled(featureKey, userId, Object.assign(Object.assign({}, attributes), customAttributes));
    return enabled;
});
export default isOptimizelyVanillaFeatureEnabled;
//# sourceMappingURL=isOptimizelyVanillaFeatureEnabled.js.map